import { useEditMarkedQuiz } from '@repo/api/quiz/useEditMarkedQuiz';
import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { Lock } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { toasterMessageHandler } from '@/lib/toaster-message-handler';

interface RecalculateMarkedAlertDialogProps {
  id?: string;
  attemptId?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function RecalculateMarkedAlertDialog(recalculateMarkedAlertDialogProps: RecalculateMarkedAlertDialogProps) {
  const { id, attemptId, open, onOpenChange } = recalculateMarkedAlertDialogProps;
  const { mutateAsync, isPending } = useEditMarkedQuiz();

  const onRecalculateMarked = async () => {
    if (!id || !attemptId) return;
    await mutateAsync({
      id: id,
      attemptId: attemptId,
      recalculateMarked: true,
    }).catch((error) => {
      toasterMessageHandler(quizErrorMessages, error);
    });
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={'sm:max-w-96'}>
        <AlertDialogBody>
          <AlertDialogHeader>
            <FeaturedIcon size={'lg'}>
              <Lock />
            </FeaturedIcon>
            <div className={'flex min-w-0 grow flex-col gap-0.5'}>
              <AlertDialogTitle>Przelicz automatycznie</AlertDialogTitle>
              <AlertDialogDescription className={'text-muted-foreground text-xs'}>
                Czy na pewno chcesz ponownie przeliczyć wynik tego podejścia? Operacja nadpisze aktualną ocenę stanem automatycznej oceny.
              </AlertDialogDescription>
            </div>
          </AlertDialogHeader>
        </AlertDialogBody>
        <AlertDialogFooter className={'border-border-primary dark:bg-card bg-accent border-t'}>
          <AlertDialogCancel disabled={isPending}>Anuluj</AlertDialogCancel>
          <AlertDialogAction onClick={onRecalculateMarked} disabled={isPending}>
            Potwierdź
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
